export enum NotificationType {
  ABSENCE_STATUS_CHANGED = 'ABSENCE_STATUS_CHANGED',
  ABSENCE_CREATED = 'ABSENCE_CREATED',
  NEW_FORUM_THREAD = 'NEW_FORUM_THREAD',
  FORUM_THREAD_RESPONSE = 'FORUM_THREAD_RESPONSE',
  USER_DOCUMENT_ABOUT_TO_EXPIRE = 'USER_DOCUMENT_ABOUT_TO_EXPIRE',
  EXPORT_COMPLETED = 'EXPORT_COMPLETED',
  NEW_INFRINGEMENT = 'NEW_INFRINGEMENT',
  INFRINGEMENT_LEADER_COMMENT_CHANGED = 'INFRINGEMENT_LEADER_COMMENT_CHANGED',
  INFRINGEMENT_EXPLANATION_CHANGED = 'INFRINGEMENT_EXPLANATION_CHANGED',
  INFRINGEMENT_REMINDER = 'INFRINGEMENT_REMINDER',
  NEW_WORK_INFRINGEMENT = 'NEW_WORK_INFRINGEMENT',
  WORK_INFRINGEMENT_LEADER_COMMENT_CHANGED = 'WORK_INFRINGEMENT_LEADER_COMMENT_CHANGED',
  WORK_INFRINGEMENT_RECEIPTED = 'WORK_INFRINGEMENT_RECEIPTED',
  WORK_INFRINGEMENT_REMINDER = 'WORK_INFRINGEMENT_REMINDER',
  NEW_TACHOGRAPH_INFRINGEMENT = 'NEW_TACHOGRAPH_INFRINGEMENT',
  TACHOGRAPH_INFRINGEMENT_LEADER_COMMENT_CHANGED = 'TACHOGRAPH_INFRINGEMENT_LEADER_COMMENT_CHANGED',
  TACHOGRAPH_INFRINGEMENT_RECEIPTED = 'TACHOGRAPH_INFRINGEMENT_RECEIPTED',
  TACHOGRAPH_INFRINGEMENT_REMINDER = 'TACHOGRAPH_INFRINGEMENT_REMINDER',
  ISSUE_REMINDER = 'ISSUE_REMINDER',
  ANY = '*',
}

export enum APP_NOTIFICATION_STATUS {
  SEEN = 'SEEN',
  UNSEEN = 'UNSEEN',
  INTERACTED = 'INTERACTED',
  ARCHIVED = 'ARCHIVED',
}
